import {
	OrderDirection,
	TableHeader,
	TableFilter,
	TableInputFilter,
	TableSelectFilter,
	TableDateFilter,
} from '@beego/ngx-table';
import { translate } from '@shared-libs/helpers';
import { DeviceTypeProvider } from '@internal-providers/device-type.provider';
import { AppModule } from '@app/app.module';

export class DeviceTableFactory {
	public static getHeaders(): [
		Array<TableHeader>,
		Array<TableHeader>,
		Array<TableHeader>,
		Array<TableHeader>,
		Array<TableHeader>,
		Array<TableHeader>,
	] {
		return [
			[
				// ALL
				new TableHeader(translate('DEVICE.TYPE'), ['DeviceType', 'name', OrderDirection.asc], 3),
				new TableHeader(translate('DEVICE.NOTE'), ['note'], 3),
				new TableHeader(),
				new TableHeader(),
				new TableHeader(),
			],
			[
				// IN STOCK
				new TableHeader(),
				new TableHeader(translate('DEVICE.TYPE'), ['DeviceType', 'name', OrderDirection.asc], 3),
				new TableHeader(translate('DEVICE.NOTE'), ['note'], 5),
			],
			[
				// IN LOAN
				new TableHeader(translate('LOAN.CLIENT'), null, 3),
				new TableHeader(translate('LOAN.NUMBER_OF_DEVICES'), null, 2),
				new TableHeader(translate('LOAN.STARTS_AT'), ['startsAt', OrderDirection.asc], 2),
				new TableHeader(translate('LOAN.ENDS_AT'), ['endsAt'], 2),

				new TableHeader(),
				new TableHeader(),
			],
			[
				// RETURNED
				new TableHeader(),
				new TableHeader(translate('DEVICE.TYPE'), ['DeviceType', 'name', OrderDirection.asc], 3),
				new TableHeader(translate('DEVICE.NOTE'), ['note'], 8),
				new TableHeader(),
			],
			[
				// IN REFURBISH
				new TableHeader(),
				new TableHeader(translate('DEVICE.TYPE'), ['DeviceType', 'name', OrderDirection.asc], 3),
				new TableHeader(translate('DEVICE.NOTE'), ['note'], 8),
				new TableHeader(),
			],
			[
				// DISABLED
				new TableHeader(),
				new TableHeader(translate('DEVICE.TYPE'), ['DeviceType', 'name', OrderDirection.asc], 3),
				new TableHeader(translate('DEVICE.NOTE'), ['note'], 8),
				new TableHeader(),
			],
		];
	}

	public static getFilters(): { [key: string]: TableFilter } {
		const deviceTypeProvider: DeviceTypeProvider = AppModule.injector.get(DeviceTypeProvider);

		return {
			typeFilter: new TableSelectFilter({
				property: 'DeviceType.name',
				name: translate('FILTERS.DEVICETYPE.TITLE'),
				data: async () =>
					(await deviceTypeProvider.getAll()).map((deviceType) => ({
						name: deviceType.name,
						value: deviceType.id,
					})),
				resource: 'online',
				placeholder: translate('FILTERS.DEVICETYPE.PLACEHOLDER'),
			}),
			serialFilter: new TableInputFilter({
				property: 'serial',
				name: translate('FILTERS.SERIALNUMBER.TITLE'),
				placeholder: translate('FILTERS.SERIALNUMBER.PLACEHOLDER'),
			}),
			descriptionFilter: new TableInputFilter({
				property: 'description',
				name: translate('FILTERS.DESCRIPTION.TITLE'),
				placeholder: translate('FILTERS.DESCRIPTION.PLACEHOLDER'),
			}),
			noteFilter: new TableInputFilter({
				property: 'note',
				name: translate('FILTERS.NOTE.TITLE'),
				placeholder: translate('FILTERS.NOTE.PLACEHOLDER'),
			}),
		};
	}

	public static getLoanFilters(): { [key: string]: TableFilter } {
		const deviceTypeProvider: DeviceTypeProvider = AppModule.injector.get(DeviceTypeProvider);

		return {
			startsAtFilter: new TableDateFilter({
				property: 'startsAt',
				name: translate('FILTERS.STARTS_AT.TITLE'),
			}),
			endsAtFilter: new TableDateFilter({
				property: 'endsAt',
				name: translate('FILTERS.ENDS_AT.TITLE'),
			}),
			typeFilter: new TableSelectFilter({
				property: 'DeviceType.id',
				name: translate('FILTERS.DEVICETYPE.TITLE'),
				data: async () =>
					(await deviceTypeProvider.getAll()).map((deviceType) => ({
						name: deviceType.name,
						value: deviceType.id,
					})),
				resource: 'online',
				placeholder: translate('FILTERS.DEVICETYPE.PLACEHOLDER'),
			}),
			activeFilter: new TableSelectFilter({
				property: 'isActive',
				name: translate('FILTERS.LOAN_ACTIVE.TITLE'),
				default: [true],
				data: [
					{ name: translate('FILTERS.LOAN_ACTIVE.OPTIONS.ACTIVE'), value: true },
					{ name: translate('FILTERS.LOAN_ACTIVE.OPTIONS.NOT_ACTIVE'), value: false },
				],
				resource: 'local',
				placeholder: translate('FILTERS.LOAN_ACTIVE.PLACEHOLDER'),
			}),
			clientFilter: new TableInputFilter({
				property: 'Client.name',
				name: translate('FILTERS.FIRSTNAME_NAME.TITLE'),
				placeholder: translate('FILTERS.FIRSTNAME_NAME.PLACEHOLDER'),
			}),
			partnerFilter: new TableInputFilter({
				property: 'Partner.name',
				name: translate('FILTERS.DIGIBANK_AGENCIES.TITLE'),
				placeholder: translate('FILTERS.DIGIBANK_AGENCIES.PLACEHOLDER'),
			}),
		};
	}
}
